{
  "moreActions": "Daha fazla eylem",
  "unavailable": "Kullanılamıyor, ayrıntıları görmek için genişletin"
}
